import iberianHighlands from '../assets/iberian-highlands.webp';
import affricHighlands from '../assets/affric_highlands.webp';
import centralApennines from '../assets/central_apennines.webp';
import danubeDelta from '../assets/danube_delta.webp';
import greaterCoaValley from '../assets/greater_coa_valley.webp';
import rhodopeMountains from '../assets/rhodope_mountains.webp';
import southernCarpathians from '../assets/southern_carpathians.webp';
import velebitMountains from '../assets/velebit_mountains.webp';
import nordicTaiga from '../assets/nordic_taiga.webp';
import oderDelta from '../assets/oder_delta.webp';
import dauphineAlps from '../assets/dauphine_alps.webp';

export const renderLandscapesInfo = [
  {
    id: 'SL02d',
    name: {
      es: 'Taiga Nórdica',
      pt: 'Taiga Nórdica',
      it: 'Taiga Nordica',
      ro: 'Taiga Nordică',
      de: 'Nordische Taiga',
      fr: 'Taïga nordique',
      en: 'Nordic Taiga',
    },
    country: {
      es: 'Suecia',
      pt: 'Suécia',
      it: 'Svezia',
      ro: 'Suedia',
      de: 'Schweden',
      fr: 'Suède',
      en: 'Sweden',
    },
    startYear: 2016,
    areaType: {
      es: 'Bosque boreal de coníferas, Río',
      pt: 'Floresta boreal de coníferas, Rio',
      it: 'Foresta boreale di conifere, Fiume',
      ro: 'Pădure boreală de conifere, Râu',
      de: 'Nördlicher Nadelwald, Fluss',
      fr: 'Forêt boréale de conifères, Rivière',
      en: 'Northern coniferous forest, River',
    },
    naturalProcess: {
      es: 'Dinámica fluvial',
      pt: 'Dinâmica fluvial',
      it: 'Dinamica fluviale',
      ro: 'Dinamica râurilor',
      de: 'Flussdynamik',
      fr: 'Dynamique fluviale',
      en: 'River dynamics',
    },
    keystoneSpecies: {
      es: 'Oso, Alce',
      pt: 'Urso, Alce',
      it: 'Orso, Alce',
      ro: 'Urs, Elan',
      de: 'Bär, Elch',
      fr: 'Ours, Élan',
      en: 'Bear, Moose',
    },
    moreInfo: '/p/landscape-nordic-taiga',
    icon: nordicTaiga,
    size: 3550154,
  },
  {
    id: 'AH01',
    name: {
      es: 'Tierras Altas de Affric',
      pt: 'Terras Altas de Affric',
      it: 'Altopiani di Affric',
      ro: 'Ținuturile Înalte Affric',
      de: 'Affric Highlands',
      fr: 'Hautes terres d’Affric',
      en: 'Affric Highlands',
    },
    country: {
      es: 'Escocia',
      pt: 'Escócia',
      it: 'Scozia',
      ro: 'Scoția',
      de: 'Schottland',
      fr: 'Écosse',
      en: 'Scotland',
    },
    startYear: 2019,
    areaType: {
      es: 'Mosaico de bosque y pastizal, Turbera, Río',
      pt: 'Mosaico de floresta e pastagem, Turfeira, Rio',
      it: 'Mosaico di foresta e prateria, Torbiera, Fiume',
      ro: 'Mozaic de pădure și pășune, Turbărie, Râu',
      de: 'Wald-Grasland-Mosaik, Moorland, Fluss',
      fr: 'Mosaïque forêt-prairie, Tourbière, Rivière',
      en: 'Forest-grassland mosaic, Peatland, River',
    },
    naturalProcess: {
      es: 'Pastoreo natural, Dinámica fluvial',
      pt: 'Pastoreio natural, Dinâmica fluvial',
      it: 'Pascolo naturale, Dinamica fluviale',
      ro: 'Pășunat natural, Dinamica râurilor',
      de: 'Natürliche Beweidung, Flussdynamik',
      fr: 'Pâturage naturel, Dynamique fluviale',
      en: 'Natural grazing, River dynamics',
    },
    keystoneSpecies: {
      es: 'Castor, Gato montés escocés',
      pt: 'Castor, Gato-bravo escocês',
      it: 'Castoro, Gatto selvatico scozzese',
      ro: 'Castor, Pisică sălbatică scoțiană',
      de: 'Biber, Schottische Wildkatze',
      fr: 'Castor, Chat sauvage écossais',
      en: 'Beaver, Scottish wildcat',
    },
    moreInfo: '/p/landscape-affric-highlands',
    icon: affricHighlands,
    size: null,
  },
  {
    id: 'OD01c',
    name: {
      es: 'Delta del Oder',
      pt: 'Delta do Oder',
      it: 'Delta dell’Oder',
      ro: 'Delta Oderului',
      de: 'Oderdelta',
      fr: 'Delta de l’Oder',
      en: 'Oder Delta',
    },
    country: {
      es: 'Alemania, Polonia',
      pt: 'Alemanha, Polónia',
      it: 'Germania, Polonia',
      ro: 'Germania, Polonia',
      de: 'Deutschland, Polen',
      fr: 'Allemagne, Pologne',
      en: 'Germany, Poland',
    },
    startYear: 2012,
    areaType: {
      es: 'Delta fluvial',
      pt: 'Delta fluvial',
      it: 'Delta fluviale',
      ro: 'Deltă fluvială',
      de: 'Flussdelta',
      fr: 'Delta fluvial',
      en: 'River Delta',
    },
    naturalProcess: {
      es: 'Inundación',
      pt: 'Inundação',
      it: 'Inondazione',
      ro: 'Inundații',
      de: 'Überflutung',
      fr: 'Inondation',
      en: 'Flooding',
    },
    keystoneSpecies: {
      es: 'Otro',
      pt: 'Outro',
      it: 'Altro',
      ro: 'Altul',
      de: 'Andere',
      fr: 'Autre',
      en: 'Other',
    },
    moreInfo: '/p/landscape-oder-delta',
    icon: oderDelta,
    size: 250000,
  },
  {
    id: 'GCV01b',
    name: {
      es: 'Gran Valle del Côa',
      pt: 'Grande Vale do Côa',
      it: 'Grande Valle del Côa',
      ro: 'Marea Vale Côa',
      de: 'Großes Côa-Tal',
      fr: 'Grande vallée du Côa',
      en: 'Greater Cõa Valley',
    },
    country: {
      es: 'Portugal',
      pt: 'Portugal',
      it: 'Portogallo',
      ro: 'Portugalia',
      de: 'Portugal',
      fr: 'Portugal',
      en: 'Portugal',
    },
    startYear: 2011,
    areaType: {
      es: 'Vegetación mediterránea',
      pt: 'Vegetação mediterrânica',
      it: 'Vegetazione mediterranea',
      ro: 'Vegetație mediteraneană',
      de: 'Mediterrane Vegetation',
      fr: 'Végétation méditerranéenne',
      en: 'Mediterranean vegetation',
    },
    naturalProcess: {
      es: 'Pastoreo natural',
      pt: 'Pastoreio natural',
      it: 'Pascolo naturale',
      ro: 'Pășunat natural',
      de: 'Natürliche Beweidung',
      fr: 'Pâturage naturel',
      en: 'Natural grazing',
    },
    keystoneSpecies: {
      es: 'Lince, Buitre, Lobo',
      pt: 'Lince, Abutre, Lobo',
      it: 'Lince, Avvoltoio, Lupo',
      ro: 'Râs, Vultur, Lup',
      de: 'Luchs, Geier, Wolf',
      fr: 'Lynx, Vautour, Loup',
      en: 'Lynx, Vulture, Wolf',
    },
    moreInfo: '/p/landscape-greater-coa-valley',
    icon: greaterCoaValley,
    size: 100000,
  },
  {
    id: 'IH01b',
    name: {
      es: 'Tierras Altas Ibéricas',
      pt: 'Terras Altas Ibéricas',
      it: 'Altopiani Iberici',
      ro: 'Ținuturile Înalte Iberice',
      de: 'Iberisches Hochland',
      fr: 'Hautes terres ibériques',
      en: 'Iberian Highlands',
    },
    country: {
      es: 'España',
      pt: 'Espanha',
      it: 'Spagna',
      ro: 'Spania',
      de: 'Spanien',
      fr: 'Espagne',
      en: 'Spain',
    },
    startYear: 2022,
    areaType: {
      es:
        'Mosaico de bosque y pastizal, Lagos de agua dulce, Montañoso, Bosque templado caducifolio',
      pt:
        'Mosaico de floresta e pastagem, Lagos de água doce, Montanhoso, Floresta temperada caducifólia',
      it: 'Mosaico di foresta e prateria, Laghi d’acqua dolce, Montuoso, Foresta temperata decidua',
      ro: 'Mozaic de pădure și pășune, Lacuri de apă dulce, Montan, Pădure temperată de foioase',
      de: 'Wald-Grasland-Mosaik, Süßwasserseen, Gebirge, Gemäßigter Laubwald',
      fr: 'Mosaïque forêt-prairie, Lacs d’eau douce, Montagneux, Forêt tempérée décidue',
      en: 'Forest-grassland mosaic, Freshwater lakes, Mountainous, Temperate deciduous forest',
    },
    naturalProcess: {
      es: 'Pastoreo natural, Dinámica fluvial',
      pt: 'Pastoreio natural, Dinâmica fluvial',
      it: 'Pascolo naturale, Dinamica fluviale',
      ro: 'Pășunat natural, Dinamica râurilor',
      de: 'Natürliche Beweidung, Flussdynamik',
      fr: 'Pâturage naturel, Dynamique fluviale',
      en: 'Natural grazing, River dynamics',
    },
    keystoneSpecies: {
      es: 'Caballos salvajes, Íbice, Lince, Ciervo rojo, Corzo, Buitre',
      pt: 'Cavalos assilvestrados, Íbex, Lince, Veado-vermelho, Corço, Abutre',
      it: 'Cavalli inselvatichiti, Stambecco, Lince, Cervo rosso, Capriolo, Avvoltoio',
      ro: 'Cai sălbăticiți, Ibex, Râs, Cerb roșu, Căprior, Vultur',
      de: 'Wildpferde, Steinbock, Luchs, Rothirsch, Reh, Geier',
      fr: 'Chevaux férals, Bouquetin, Lynx, Cerf élaphe, Chevreuil, Vautour',
      en: 'Feral horses, Ibex, Lynx, Red deer, Roe deer, Vulture',
    },
    moreInfo: '/p/landscape-iberian-highlands',
    icon: iberianHighlands,
    size: 850000,
  },
  {
    id: 'DA01',
    name: {
      es: 'Alpes del Delfinado',
      pt: 'Alpes do Delfinado',
      it: 'Alpi del Delfinato',
      ro: 'Alpii Dauphiné',
      de: 'Dauphiné-Alpen',
      fr: 'Alpes du Dauphiné',
      en: 'Dauphine Alps',
    },
    country: {
      es: 'Francia',
      pt: 'França',
      it: 'Francia',
      ro: 'Franța',
      de: 'Frankreich',
      fr: 'France',
      en: 'France',
    },
    startYear: 2025,
    areaType: {
      es: 'Mosaico de bosque y pastizal, Montañoso, Río',
      pt: 'Mosaico de floresta e pastagem, Montanhoso, Rio',
      it: 'Mosaico di foresta e prateria, Montuoso, Fiume',
      ro: 'Mozaic de pădure și pășune, Montan, Râu',
      de: 'Wald-Grasland-Mosaik, Gebirge, Fluss',
      fr: 'Mosaïque forêt-prairie, Montagneux, Rivière',
      en: 'Forest-grassland mosaic, Mountainous, River',
    },
    naturalProcess: {
      es: 'Depredación, Carroñeo',
      pt: 'Predação, Necrofagia',
      it: 'Predazione, Necrofagia',
      ro: 'Prădare, Necrofagie',
      de: 'Prädation, Aasfressen',
      fr: 'Prédation, Charognage',
      en: 'Predation, Scavenging',
    },
    keystoneSpecies: {
      es: 'Íbice, Buitre, Lobo',
      pt: 'Íbex, Abutre, Lobo',
      it: 'Stambecco, Avvoltoio, Lupo',
      ro: 'Ibex, Vultur, Lup',
      de: 'Steinbock, Geier, Wolf',
      fr: 'Bouquetin, Vautour, Loup',
      en: 'Ibex, Vulture, Wolf',
    },
    moreInfo: '/p/landscape-dauphine-alps',
    icon: dauphineAlps,
    size: 500000,
  },
  {
    id: 'CA02c',
    name: {
      es: 'Apeninos Centrales',
      pt: 'Apeninos Centrais',
      it: 'Appennini Centrali',
      ro: 'Apeninii Centrali',
      de: 'Zentraler Apennin',
      fr: 'Apennins centraux',
      en: 'Central Appenines',
    },
    country: {
      es: 'Italia',
      pt: 'Itália',
      it: 'Italia',
      ro: 'Italia',
      de: 'Italien',
      fr: 'Italie',
      en: 'Italy',
    },
    startYear: 2013,
    areaType: {
      es: 'Montañoso',
      pt: 'Montanhoso',
      it: 'Montuoso',
      ro: 'Montan',
      de: 'Gebirge',
      fr: 'Montagneux',
      en: 'Mountainous',
    },
    naturalProcess: {
      es: '-',
      pt: '-',
      it: '-',
      ro: '-',
      de: '-',
      fr: '-',
      en: '-',
    },
    keystoneSpecies: {
      es: 'Oso, Rebeco, Buitre',
      pt: 'Urso, Camurça, Abutre',
      it: 'Orso, Camoscio, Avvoltoio',
      ro: 'Urs, Capră neagră, Vultur',
      de: 'Bär, Gämse, Geier',
      fr: 'Ours, Chamois, Vautour',
      en: 'Bear, Chamois, Vulture',
    },
    moreInfo: '/p/landscape-central-apennines',
    icon: centralApennines,
    size: 100000,
  },
  {
    id: 'VM01',
    name: {
      es: 'Montañas Velebit',
      pt: 'Montanhas Velebit',
      it: 'Monti Velebit',
      ro: 'Munții Velebit',
      de: 'Velebit-Gebirge',
      fr: 'Montagnes du Velebit',
      en: 'Velebit Mountains',
    },
    country: {
      es: 'Croacia',
      pt: 'Croácia',
      it: 'Croazia',
      ro: 'Croația',
      de: 'Kroatien',
      fr: 'Croatie',
      en: 'Croatia',
    },
    startYear: 2012,
    areaType: {
      es: 'Mosaico de bosque y pastizal, Vegetación mediterránea, Montañoso',
      pt: 'Mosaico de floresta e pastagem, Vegetação mediterrânica, Montanhoso',
      it: 'Mosaico di foresta e prateria, Vegetazione mediterranea, Montuoso',
      ro: 'Mozaic de pădure și pășune, Vegetație mediteraneană, Montan',
      de: 'Wald-Grasland-Mosaik, Mediterrane Vegetation, Gebirge',
      fr: 'Mosaïque forêt-prairie, Végétation méditerranéenne, Montagneux',
      en: 'Forest-grassland mosaic, Mediterranean vegetation, Mountainous',
    },
    naturalProcess: {
      es: 'Escarabajo descortezador, Pastoreo natural, Depredación',
      pt: 'Escaravelho-da-casca, Pastoreio natural, Predação',
      it: 'Bostrico, Pascolo naturale, Predazione',
      ro: 'Gândac de scoarță, Pășunat natural, Prădare',
      de: 'Borkenkäfer, Natürliche Beweidung, Prädation',
      fr: 'Scolyte, Pâturage naturel, Prédation',
      en: 'Bark beetle, Natural grazing, Predation',
    },
    keystoneSpecies: {
      es:
        'Oso, Gamo, Jabalí salvaje, Ganado asilvestrado, Caballos salvajes, Lince, Ciervo rojo, Corzo, Lobo',
      pt:
        'Urso, Gamo, Javali assilvestrado, Gado assilvestrado, Cavalos assilvestrados, Lince, Veado-vermelho, Corço, Lobo',
      it:
        'Orso, Daino, Cinghiale inselvatichito, Bovini inselvatichiti, Cavalli inselvatichiti, Lince, Cervo rosso, Capriolo, Lupo',
      ro:
        'Urs, Cerb lopătar, Mistreț sălbăticit, Bovine sălbăticite, Cai sălbăticiți, Râs, Cerb roșu, Căprior, Lup',
      de:
        'Bär, Damhirsch, Wildschwein, Verwilderte Rinder, Wildpferde, Luchs, Rothirsch, Reh, Wolf',
      fr:
        'Ours, Daim, Sanglier féral, Bovins férals, Chevaux férals, Lynx, Cerf élaphe, Chevreuil, Loup',
      en:
        'Bear, Fallow deer, Feral boar, Feral cattle, Feral horses, Lynx, Red deer, Roe deer, Wolf',
    },
    moreInfo: '/p/landscape-velebit-mountains',
    icon: velebitMountains,
    size: 220000,
  },
  {
    id: 'SC02d',
    name: {
      es: 'Cárpatos Meridionales',
      pt: 'Cárpatos Meridionais',
      it: 'Carpazi Meridionali',
      ro: 'Carpații Meridionali',
      de: 'Südkarpaten',
      fr: 'Carpates méridionales',
      en: 'Southern Carpathians',
    },
    country: {
      es: 'Rumanía',
      pt: 'Roménia',
      it: 'Romania',
      ro: 'România',
      de: 'Rumänien',
      fr: 'Roumanie',
      en: 'Romania',
    },
    startYear: 2012,
    areaType: {
      es: 'Mosaico de bosque y pastizal, Montañoso',
      pt: 'Mosaico de floresta e pastagem, Montanhoso',
      it: 'Mosaico di foresta e prateria, Montuoso',
      ro: 'Mozaic de pădure și pășune, Montan',
      de: 'Wald-Grasland-Mosaik, Gebirge',
      fr: 'Mosaïque forêt-prairie, Montagneux',
      en: 'Forest-grassland mosaic, Mountainous',
    },
    naturalProcess: {
      es: 'Escarabajo descortezador, Otro, Depredación',
      pt: 'Escaravelho-da-casca, Outro, Predação',
      it: 'Bostrico, Altro, Predazione',
      ro: 'Gândac de scoarță, Altul, Prădare',
      de: 'Borkenkäfer, Andere, Prädation',
      fr: 'Scolyte, Autre, Prédation',
      en: 'Bark beetle, Other, Predation',
    },
    keystoneSpecies: {
      es: 'Bisonte',
      pt: 'Bisonte',
      it: 'Bisonte',
      ro: 'Bizon',
      de: 'Bison',
      fr: 'Bison',
      en: 'Bison',
    },
    moreInfo: '/p/landscape-southern-carpathians',
    icon: southernCarpathians,
    size: 100000,
  },
  {
    id: 'DD25',
    name: {
      es: 'Delta del Danubio',
      pt: 'Delta do Danúbio',
      it: 'Delta del Danubio',
      ro: 'Delta Dunării',
      de: 'Donaudelta',
      fr: 'Delta du Danube',
      en: 'Danube Delta',
    },
    country: {
      es: 'Ucrania, Rumanía, Moldavia',
      pt: 'Ucrânia, Roménia, Moldávia',
      it: 'Ucraina, Romania, Moldavia',
      ro: 'Ucraina, România, Moldova',
      de: 'Ukraine, Rumänien, Moldau',
      fr: 'Ukraine, Roumanie, Moldavie',
      en: 'Ukraine, Romania, Moldova',
    },
    startYear: 2011,
    areaType: {
      es: 'Humedales',
      pt: 'Zonas húmidas',
      it: 'Zone umide',
      ro: 'Zone umede',
      de: 'Feuchtgebiete',
      fr: 'Zones humides',
      en: 'Wetlands',
    },
    naturalProcess: {
      es: 'Inundación, Pastoreo natural, Otro, Dinámica fluvial',
      pt: 'Inundação, Pastoreio natural, Outro, Dinâmica fluvial',
      it: 'Inondazione, Pascolo naturale, Altro, Dinamica fluviale',
      ro: 'Inundații, Pășunat natural, Altul, Dinamica râurilor',
      de: 'Überflutung, Natürliche Beweidung, Andere, Flussdynamik',
      fr: 'Inondation, Pâturage naturel, Autre, Dynamique fluviale',
      en: 'Flooding, Natural grazing, Other, River dynamics',
    },
    keystoneSpecies: {
      es: 'Castor, Caballos salvajes, Búfalo de agua',
      pt: 'Castor, Cavalos assilvestrados, Búfalo-de-água',
      it: 'Castoro, Cavalli inselvatichiti, Bufalo d’acqua',
      ro: 'Castor, Cai sălbăticiți, Bivol de apă',
      de: 'Biber, Wildpferde, Wasserbüffel',
      fr: 'Castor, Chevaux férals, Buffle d’eau',
      en: 'Beaver, Feral horses, Water buffalo',
    },
    moreInfo: '/p/landscape-danube-delta',
    icon: danubeDelta,
    size: 180000,
  },
  {
    id: 'RM01b',
    name: {
      es: 'Montañas Ródope',
      pt: 'Montanhas Ródope',
      it: 'Monti Rodopi',
      ro: 'Munții Rodopi',
      de: 'Rhodopen',
      fr: 'Montagnes des Rhodopes',
      en: 'Rhodope Mountains',
    },
    country: {
      es: 'Bulgaria',
      pt: 'Bulgária',
      it: 'Bulgaria',
      ro: 'Bulgaria',
      de: 'Bulgarien',
      fr: 'Bulgarie',
      en: 'Bulgaria',
    },
    startYear: 2014,
    areaType: {
      es: 'Mosaico de bosque y pastizal',
      pt: 'Mosaico de floresta e pastagem',
      it: 'Mosaico di foresta e prateria',
      ro: 'Mozaic de pădure și pășune',
      de: 'Wald-Grasland-Mosaik',
      fr: 'Mosaïque forêt-prairie',
      en: 'Forest-grassland mosaic',
    },
    naturalProcess: {
      es: 'Pastoreo natural, Depredación',
      pt: 'Pastoreio natural, Predação',
      it: 'Pascolo naturale, Predazione',
      ro: 'Pășunat natural, Prădare',
      de: 'Natürliche Beweidung, Prädation',
      fr: 'Pâturage naturel, Prédation',
      en: 'Natural grazing, Predation',
    },
    keystoneSpecies: {
      es: 'Bisonte, Caballos salvajes, Ciervo rojo, Corzo, Buitre',
      pt: 'Bisonte, Cavalos assilvestrados, Veado-vermelho, Corço, Abutre',
      it: 'Bisonte, Cavalli inselvatichiti, Cervo rosso, Capriolo, Avvoltoio',
      ro: 'Bizon, Cai sălbăticiți, Cerb roșu, Căprior, Vultur',
      de: 'Bison, Wildpferde, Rothirsch, Reh, Geier',
      fr: 'Bison, Chevaux férals, Cerf élaphe, Chevreuil, Vautour',
      en: 'Bison, Feral horses, Red deer, Roe deer, Vulture',
    },
    moreInfo: '/p/landscape-rhodope-mountains',
    icon: rhodopeMountains,
    size: 250000,
  },
];
